export default {
  CREATE_MEMBERSHIP(state, payload) {
    // state.membership.result.unshift(payload);
    // state.membership.totalCount += 1;
  },
  UPDATE_MEMBERSHIP(state, payload) {
    // let index = state.membership.result.findIndex((x) => x._id == payload._id);
    // state.membership.result.splice(index, 1, payload);
  },
  GET_MEMBERSHIP(state, payload) {
    // let index = state.membership.result.findIndex((x) => x._id == payload._id);
    // state.membership.result.splice(index, 1, payload);
  },
  GET_ALL_MEMBERSHIP(state, payload) {
    state.get_all_membership = payload;
  },
  GET_MEMBERSHIP_FOR_ADMIN(state, payload) {
    state.admin_membership = payload;
  },
  DELETE_MEMBERSHIP(state, payload) {
    // let index = state.membership.result.findIndex((x) => x._id == payload._id);
    // state.membership.result.splice(index, 1);
    // state.membership.totalCount -= 1;
  },

  GET_COUPON(state, payload) {
    state.getCoupon = payload;
  },

  GET_FEATURE(state, payload) {
    state.getAllFeatures = payload;
  },

  GET_CATEGORY(state, payload) {
    state.getAllCategory = payload;
  },
};
